import React from 'react';
import ContentLoader from 'react-content-loader';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';

export const ReturnActionButtonPlaceholder = () => (
  <>
    <MobilePlaceholder>
      <Wrapper>
        <rect x="0" y="0" rx="0" ry="0" width="700" height="44" />
      </Wrapper>
    </MobilePlaceholder>
    <TabletPlaceholder>
      <Wrapper>
        <rect x="0" y="0" rx="0" ry="0" width="170" height="44" />
      </Wrapper>
    </TabletPlaceholder>
  </>
);

const MobilePlaceholder = styled.div`
  width: 100%;

  ${up('sm')} {
    display: none;
  }
`;
const TabletPlaceholder = styled.div`
  display: none;

  ${up('sm')} {
    display: block;
    height: 44px;
  }
`;

const Wrapper = styled(ContentLoader)`
  border-radius: 6px;
  height: 44px;
  width: 100%;
  margin-top: 10px;

  ${up('sm')} {
    width: 170px;
    margin-left: 16px;
    margin-top: 0;
  }
`;
